(function () {
  class WinningsText extends PIXI.Container {
    constructor() {
      super();

      this._container = null;
      this._mainText = null;
      this._multiplierSparks = null;

      this._textBouncing = false;
      this._sparkleAnimPlaying = false;

      Reflex.registerEventHandler('ready', this.onReady.bind(this));
    }

    onReady = function () {
      this._container = resourceManager.get(this.name + ':winningsTextContainer');
      this._mainText = resourceManager.get(this.name + ':winningsTextContainer:winningsText');
      this._multiplierSparks = resourceManager.get(this.name + ':winningsTextContainer:multiplierSparks');

      this._multiplierSparks.anchor.x = 0.5;
      this._multiplierSparks.anchor.y = 0.5;
      this._multiplierSparks.gotoAndStop(0);
      this._multiplierSparks.visible = false;

      this.show(false);

      Reflex.deregisterEventHandler('ready', this.onReady.bind(this));
    };

    bounceText = function (durationInMs = 500) {
      if (!this._textBouncing) {
        this._textBouncing = true;
        gsap.fromTo(
          this._mainText.scale,
          {
            x: 0,
            y: 0,
          },
          {
            x: 1,
            y: 1,
            duration: durationInMs / 1000,
            ease: 'bounce.out',
            onComplete: () => {
              this._textBouncing = false;
            },
          }
        );
      }
    };

    isTextBouncing = function () {
      return this._textBouncing;
    };

    setText = function (value) {
      const text = gdk.formatCurrency(value);
      this._mainText.setText(text);
    };

    show = function (show, value) {
      this._container.visible = show;

      if (value) {
        this.setText(value);
      }
    };

    setScale = function (scale) {
      this._container.scale.set(scale);
    };

    playSparkleAnim() {
      if (this._sparkleAnimPlaying === false) {
        this._sparkleAnimPlaying = true;
        this._multiplierSparks.onComplete = () => {
          this._multiplierSparks.gotoAndStop(0);
          this._multiplierSparks.visible = false;
          this._sparkleAnimPlaying = false;
        };
        this._multiplierSparks.visible = true;
        this._multiplierSparks.gotoAndPlay(0);
      }
    }

    sparkleAnimPlaying() {
      return this._sparkleAnimPlaying;
    }
  }

  let winningsTextCreator = function (json) {
    return new WinningsText();
  };

  resourceManager.registerObjectType(
    'winningsText',
    winningsTextCreator,
    function () {},
    function () {
      return [];
    }
  );
})();
